import config from 'config';

import { FC } from 'react';
// Redux
import { useAppSelector } from 'hooks/useStore';
import { selectResult } from 'store/player/playerSelectors';
import { selectQuiz } from 'store/quiz/quizSelectors';
import IQuiz from 'models/Quiz';
// Components
import { QRCodeCanvas } from "qrcode.react";

type Props = {
  isLargeScreen: boolean;
  isCompact?: boolean;
}

const QRCode:FC<Props> = ({ isLargeScreen, isCompact = false }) => {
  const result:any = useAppSelector(selectResult);
  const storeQuiz = useAppSelector(selectQuiz);
  const quiz:IQuiz | null = storeQuiz || result?.quiz || null;

  const qrCodeLink = quiz?.publicLeaderboard.quizQRCodeLink || `${config.quizURL}/quiz/${quiz?.quizNameSlug}`;

  if (!quiz || !quiz.publicLeaderboard.quizQRCodeEnabled) return null;

  if (isCompact) {
    return (
      <div className="flex-1 min-w-0 min-h-0 flex flex-col items-center justify-center gap-1">
        <div className="flex-1 min-h-0 w-full flex items-center justify-center">
          <div className="aspect-square h-full max-w-full flex flex-col p-1 bg-white text-black rounded-xl">
            <QRCodeCanvas
              value={qrCodeLink}
              level="H"
              size={128}
              style={{ width: '100%', height: '100%' }}
              imageSettings={{
                src: quiz.publicLeaderboard.quizQRCodeLogo || '',
                width: 40,
                height: 40,
                excavate: true
              }}
            />
          </div>
        </div>
        <h2
          className="shrink-0 w-full truncate italic uppercase text-xs font-extrabold text-center"
          style={{
            background: `linear-gradient(90deg, ${quiz.publicLeaderboard.primaryColor}, ${quiz.publicLeaderboard.secondaryColor})`,
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          {quiz?.publicLeaderboard.quizQRCodeTitle}
        </h2>
      </div>
    );
  }

  const qrMaxSize = isLargeScreen ? 800 : 128;
  const qrDisplayMax = isLargeScreen ? 720 : 128;

  return (
    <div className="flex flex-col items-center justify-center landscape:justify-end w-full h-full min-w-0 min-h-0">
      <div className="flex-1 min-h-0 w-full flex items-center justify-center mb-4">
        <div
          className="aspect-square max-w-full max-h-full p-2 bg-white text-black rounded-xl xl:p-4"
          style={{ width: `min(100%, ${qrDisplayMax}px, 55vh)` }}
        >
          <QRCodeCanvas
            value={qrCodeLink}
            level="H"
            size={qrMaxSize}
            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
            imageSettings={{
              src: quiz.publicLeaderboard.quizQRCodeLogo || '',
              width: isLargeScreen ? 240 : 40,
              height: isLargeScreen ? 240 : 40,
              excavate: true
            }}
          />
        </div>
      </div>

      <h2
        className="shrink-0 max-w-full truncate pr-3 italic uppercase text-lg font-extrabold text-center sm:text-3xl xl:text-5xl"
        style={{
          background: `linear-gradient(90deg, ${quiz.publicLeaderboard.primaryColor}, ${quiz.publicLeaderboard.secondaryColor})`,
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
        }}
      >
        {quiz?.publicLeaderboard.quizQRCodeTitle}
      </h2>
    </div>
  );
}

export default QRCode;
